// src/pages/income/env/total/IncomeEnvTotalDraftNew.jsx
// ✅ 환경/종합 "수입데이터+기안 작성" 페이지 — 얇은 래퍼(경영팀과 동일 원칙).
import React from "react";
import IncomeDraftNew from "../../_shared/IncomeDraftNew";
import incomeEnvTotalDraftConfig from "./incomeEnvTotalDraftConfig";

export default function IncomeEnvTotalDraftNew() {
  return <IncomeDraftNew config={incomeEnvTotalDraftConfig} />;
}
